import { NgModule, OpaqueToken, Optional, SkipSelf } from "@angular/core";
import { ReportService } from "./report/report.service";
export class ResourceModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('ResourceModule is already loaded. Import it in the AppModule only');
        }
    }
    /**
     * Provide the configuration service and the application key used in the configuration context.
     * @param config
     * @return ModuleWithProviders
     */
    static forRoot(config) {
        return {
            ngModule: ResourceModule,
            providers: [
                { provide: ResourceModule.RESOURCE_NAMESPACE_KEY, useValue: config.nameSpace },
                { provide: ResourceModule.ENTITY_NAMES_KEY, useValue: config.entityNames },
                { provide: ResourceModule.SEARCH_NAMES_KEY, useValue: config.searchNames },
                { provide: ResourceModule.ACTION_NAMES_KEY, useValue: config.actionNames },
                { provide: ResourceModule.RESOURCE_USE_ASYNC, useValue: config.useAsync },
                ReportService
            ]
        };
    }
}
/**
 * Provider application key - identifies the application in the configuration context.
 * @type {OpaqueToken}
 */
ResourceModule.RESOURCE_NAMESPACE_KEY = new OpaqueToken('resourceNamespace');
/**
 * Provider entity names key - identifies the entity resources in the configuration context.
 * @type {OpaqueToken}
 */
ResourceModule.ENTITY_NAMES_KEY = new OpaqueToken('entityNames');
/**
 * Provider search names key - identifies the search resources in the configuration context.
 * @type {OpaqueToken}
 */
ResourceModule.SEARCH_NAMES_KEY = new OpaqueToken('searchNames');
/**
 * Provider action names key - identifies the action resources in the configuration context.
 * @type {OpaqueToken}
 */
ResourceModule.ACTION_NAMES_KEY = new OpaqueToken('actionNames');
ResourceModule.RESOURCE_USE_ASYNC = new OpaqueToken('useAsync');
ResourceModule.decorators = [
    { type: NgModule, args: [{},] },
];
/** @nocollapse */
ResourceModule.ctorParameters = () => [
    { type: ResourceModule, decorators: [{ type: Optional }, { type: SkipSelf },] },
];
export class ResourceConfig {
}
//# sourceMappingURL=resource.module.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/resource/resource.module.js
// module id = 44
// module chunks = 1